import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { XIcon } from '@heroicons/react/outline';
import PropTypes from 'prop-types';
import { useRef } from 'react';
import Draggable from 'react-draggable';
import DialogActionButton from './DialogActionButton';
const Dialog = ({ title, open, setOpen, actionButton, defaultPosition, children, canBeClosed, }) => {
    const nodeRef = useRef(null);
    const closeDialog = () => {
        if (canBeClosed) {
            setOpen(false);
        }
    };
    return open && (_jsx(Draggable, { nodeRef: nodeRef, cancel: ".dialog-action-button", bounds: "#root", handle: "#drag-handle", defaultPosition: defaultPosition, children: _jsxs("div", { ref: nodeRef, className: "overflow-visible touch-pan-auto top-0 absolute z-[1200] inline-block align-bottom bg-white rounded-lg text-left shadow-xl sm:align-middle sm:max-w-sm sm:w-full sm:p-6", children: [_jsx("div", { id: "drag-handle", className: "absolute top-0 left-0 h-20 w-full" }), _jsx("div", { className: "hidden sm:block absolute top-0 right-0 pt-4 pr-4", children: _jsxs("button", { type: "button", className: "dialog-action-button bg-white rounded-md text-gray-600 hover:text-gray-400 focus:outline-none disabled:opacity-25", onClick: closeDialog, disabled: !canBeClosed, children: [_jsx("span", { className: "sr-only", children: "Close" }), _jsx(XIcon, { className: "h-9 w-9", "aria-hidden": "true" })] }) }), _jsxs("div", { className: "py-3 text-center sm:mt-0 sm:m-4 sm:text-left", children: [_jsx("div", { id: "dialog-title", className: "mb-4", children: title }), _jsx("div", { className: "w-full", children: children })] }), _jsxs("div", { className: "mt-5 sm:mt-4 sm:flex sm:flex-row-reverse flex", children: [actionButton, _jsx(DialogActionButton, { disabled: !canBeClosed, color: 'white', triggerAction: closeDialog, text: 'Close' })] })] }) }));
};
Dialog.propTypes = {
    defaultPosition: PropTypes.shape({
        x: PropTypes.number,
        y: PropTypes.number,
    }),
};
Dialog.defaultProps = {
    defaultPosition: { x: 0, y: 0 },
};
export default Dialog;
